// extracted by mini-css-extract-plugin
module.exports = {"Iframe":"IframeBlok_Iframe__otbd0","test":"IframeBlok_test__1J_j_"};